import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import AlexaAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/AlexaAppIcon';

const AlexaStrategy = {
  previewInfo: {
    name: 'Alexa',
    iconSvg: <AlexaAppIcon size="xlarge" />,
    newTab: false,
  },
  headerInfo: {
    name: 'Alexa',
    category: 'Use Housecall Pro with your voice on the go',
    details: (
      <div>
        Introducing a new way for you to manage your company without lifting a finger. Find your next job, let your
        customers know you’re on your way, or get directions to your next job with a simple voice command through
        Housecall Pro’s new Alexa skill. Try it today on any Alexa-enabled device or on the Alexa Mobile app.
        (navigation only supported on some devices)
      </div>
    ),
    iconSvg: <AlexaAppIcon size="xlarge" />,
  },
  sellingPoints: {
    headline: 'Get started with the Alexa skill with these commands.',
    description: '',
    unorderedPoints: [
      'Alexa, ask Housecall Pro when my next job is.',
      'Alexa, ask Housecall Pro to let my next customer know I’m on my way.',
      'Alexa, ask Housecall Pro to navigate to my next job.',
    ],
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideToggle: true,
    hideCard: true,
  },
};

export default AlexaStrategy;
